import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';
import Strings from '../../translations/Translations';

export default function NotFound() {
  return (
    <Fragment>
      <div className="h-100 bg-animation">
        <div className="d-flex h-100 justify-content-center align-items-center">
          <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="h5 modal-title text-center">
                    <h4 className="mt-2">
                      <div>{Strings('application_title')}</div>
                    </h4>
                    <h5>
                      {Strings('page_not_found')}
                    </h5>
                    <Link
                      to="/"
                      className="btn btn-primary btn-shadow mt-3"
                    >
                      {Strings('go_home')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </div>
      </div>
    </Fragment>
  );
}
